import { render } from "./SimpleTabs.vue?vue&type=template&id=2a503fb6"
import script from "./SimpleTabs.vue?vue&type=script&lang=js"
export * from "./SimpleTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__